import Label from "components/Label";
import Image from "next/image";
import React, { FC } from "react";

import Media from "components/Media";
import WorkSmarterImg from "../../../../../../../public/work-smarter.png";
import WorkSmarterImgResponsive from "../../../../../../../public/work-smarter-responsive.png";

import Income from "../../../../../../../public/income.svg";

import styles from "./styles.module.scss";

const WorkSmarter: FC = () => {
  return (
    <>
      <div className={styles.img}>
        <Media at={["desktop"]}>
          <Image src={WorkSmarterImg} />
        </Media>
        <Media at={["responsive"]}>
          <Image src={WorkSmarterImgResponsive} />
        </Media>
        <Income className={styles.income} />
      </div>
      <div className={styles.information}>
        <Label className={styles.title} variant="h3" color="primary">
          Work smarter, every day
        </Label>
        <Label className={styles.description} variant="s3" color="primary">
          Focus on the stuff that really matters. We&apos;ll handle everything
          else — from easy pay automatic billing, to communication, to
          consistent job flow, and automatic scheduling — our platform works for
          you.
        </Label>
      </div>
    </>
  );
};

export default WorkSmarter;
